import { RoleType } from '../enums/RoleType';
import { RoleModel } from '../models/auth.model';

export class RoleUtils {

  static checkRole(roles: RoleModel[] | undefined, role: RoleType): boolean {
    if (!roles) { return false; }

    return roles.findIndex((r: any) => r.roleType === role) !== -1;
  }
}
